














































































import { Component, Prop } from "vue-property-decorator";
import AbpBase from "../../lib/abpbase";
import Supplier from "../../store/entities/booking/supplier";
import Editor from "@tinymce/tinymce-vue";
import TinymceInit from "../../lib/TinymceInit";
import MultiPicture from "../../components/multi-picture.vue";
import RegionSelect from "../../components/region-select.vue";
import { Survey } from "../../lib/tinymce-initial-value";
import appconst from "../../lib/appconst";
TinymceInit.height = 300;

@Component({
  components: { Editor, RegionSelect, MultiPicture },
})
export default class CreateSupplier extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;

  supplier: Supplier = new Supplier();
  type: boolean = false;
  showOnHome: boolean = false;
  tinymceInit = TinymceInit;
  uploadUrl: string = appconst.remoteServiceBaseUrl + "Picture/UploadPicture";
  survey = Survey;

  get extData() {
    return {
      supplierId: this.supplier.id,
    };
  }

  save() {
    (this.$refs.supplierForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "supplier/create",
          data: this.supplier
        });
        (this.$refs.supplierForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.supplierForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  validateSupplierTypeCheck(rule, value, callback) {
    if (!(value>=0 && value<=1)) {
      return callback(new Error("请选择供应商类型"));
    }else{
      callback();
    }
  }
  supplierRule = {
    name: [
      {
        required: true,
        message: "请输入供应商名称",
        trigger: "blur",
      },
    ],
    supplierType: [
      {
        required: true,
        validator: this.validateSupplierTypeCheck,
        trigger: "change",
      },
    ],
    phoneNumber: [
      {
        message: "请输入供应商手机号",
        trigger: "blur",
      },
    ],
    introduction: [
      {
        message: "请输入供应商简介",
        trigger: "blur",
      },
    ],
    remark: [
      {
        message: "请输入备注",
        trigger: "blur",
      },
    ],
  };
}
